var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpatialStructureEntityContainedSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #009ad9;\n      }\n\n      .cls-2 {\n        fill: #363545;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.67,19.33v-6.67h-6.67v2.5h-5.83v-4.17h2.5v-6.67h-6.67v6.67h2.5v14.17h10.83v2.5h6.67v-6.67h-6.67v2.5h-9.17v-6.67h5.83v2.5h6.67Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32 32 26 32 26 30 30 30 30 26 32 26 32 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6 32 0 32 0 26 2 26 2 30 6 30 6 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "2 6 0 6 0 0 6 0 6 2 2 2 2 6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32 6 30 6 30 2 26 2 26 0 32 0 32 6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatialStructureEntityContainedSvg);
export default __webpack_public_path__ + "static/media/SpatialStructureEntityContained_svg.90ccccffaa76e77551d56d3e2f154e10.svg";
export { ForwardRef as ReactComponent };